/**
 * Ajustes do CRM (27/10, trilha "ficha", ficha "crm-novo-desenho-ajustes"): textos da ficha da negociação, do histórico em
 * linha do tempo, do e-mail, dos produtos, das propostas e da página inicial das Configurações do CRM, em `pipeline:crm.ficha2.*`.
 * Arquivo próprio para a junção das trilhas não brigar com `crm-i18n.ts`.
 */
export const ficha2Pt = {
  reabrir: "Reabrir negociação",
  reaberta: "Negociação reaberta",
  maisOpcoes: "Mais opções da negociação",
  apagar: "Apagar negociação",
  playbook: "Abrir playbook",
  diasEtapa: "{{nome}} ({{dias}})",
  parabens: "Parabéns pela venda!",
  continuar: "Continuar",
  vendaMarcada: "{{titulo}} foi marcada como vendida.",
  vendasMes_one: "Neste mês, {{nome}} já fez {{count}} venda, somando {{total}}.",
  vendasMes_other: "Neste mês, {{nome}} já fez {{count}} vendas, somando {{total}}.",
  semResponsavel: "a negociação sem responsável",
  anotacao: "Anotação",
  criada: "Negociação criada",
  trocarEmpresa: "Trocar a empresa da negociação",
  empresaExistente: "Empresa do cadastro",
  criarEmpresa: "Criar nova empresa",
  segmento: "Segmento",
  url: "URL",
  endereco: "Endereço",
  abrirEmpresa: "Abrir página da empresa",
  infoAdicional: "Informações adicionais",
  cargo: "Cargo",
  baseLegal: "Base legal",
  basesLegais: {
    nao_sabe: "Não sei dizer / Não possuo base legal",
    consentimento: "Consentimento",
    legitimo_interesse: "Legítimo interesse",
    execucao_contrato: "Execução de contrato",
    obrigacao_legal: "Obrigação legal",
  },
  editarContato: "Editar {{nome}}",
  criarContato: "Criar novo contato",
  email: {
    de: "De",
    deAjuda: "Sai em seu nome pelo e-mail do workspace.",
    cc: "CC",
    cco: "CCO",
    semCopias: "Não há outro e-mail da negociação para copiar.",
    ccQuem: "CC: {{lista}}",
    selecionarModelo: "Selecionar modelo de e-mail",
    modelosTitulo: "Modelos de e-mail",
    modelos: "Modelo",
    configurarModelos: "Configurar modelos",
    selecionar: "Selecionar",
    semModelos: "Nenhum modelo de e-mail. Crie em Configurações do CRM > Modelos de e-mail.",
  },
  config: {
    secoes: { "modelos-email": "Modelos de e-mail", preferencias: "Preferências" },
    grupos: { time: "Seu time", processo: "Configure seu processo de venda", automatize: "Automatize processos", avancado: "Avançado", conta: "Ajustes de sua conta", produtosMarketing: "Produtos de marketing", potencialize: "Potencialize sua estratégia de vendas", acompanhamento: "Acompanhamento e aprovação de administradores" },
    usuarios: "Convites, usuários e equipes",
    itens: { equipes: "Equipes de vendas", etapasLead: "Etapas do Lead", automacao: "Automação de vendas", marketing: "Integração com Marketing", importar: "Importar dados", multivendas: "Multi-vendas", metas: "Metas", enriquecimento: "Enriquecimento de empresas", integracoes: "Integrações", privacidade: "Privacidade de dados", regionais: "Preferências regionais", whatsapp: "Venda pelo WhatsApp", reWhatsapp: "IA pelo WhatsApp", assinatura: "Assinatura eletrônica", ia: "IA para negociações e Sales Enablement", produtos: "Produtos e serviços", segmentos: "Segmentos", infoPre: "Informações pré-definidas", telefone: "Telefone virtual", exportacoes: "Gerenciamento de exportações", acoesMassa: "Gerenciamento de ações em massa", lixeira: "Lixeira", logsErros: "Logs de erros" },
    emBreve: "Em breve",
    emBreveAjuda: "Esta configuração ainda não está disponível.",
    sugestoesTitulo: "Sugestões para você",
    sugestoes: {
      campos: "Crie campos personalizados de acordo com o seu processo de vendas",
      camposBotao: "Criar campos personalizados",
      modelos: "Cadastre modelos de e-mail para enviar aos contatos pelas negociações",
      modelosBotao: "Criar modelos de e-mail",
      playbook: "Monte o playbook de vendas da sua equipe em cada etapa do funil",
      playbookBotao: "Configurar etapas do playbook",
    },
    buscar: "Buscar nas configurações",
    buscaPlaceholder: "Digite para buscar, ex.: modelos de e-mail...",
    nada: "Nenhuma configuração com esse nome.",
    celebrar: "Parabéns pela venda",
    celebrarAjuda: "Depois de marcar a venda, mostra o parabéns com as vendas do mês do responsável.",
    modelosEmail: {
      intro: "Cadastre modelos de e-mails que poderão ser enviados aos seus contatos através de suas negociações.",
      criar: "Adicionar modelo",
      editarTitulo: "Editar modelo de e-mail",
      nome_one: "Modelo de e-mail ({{count}})",
      nome_other: "Modelos de e-mail ({{count}})",
      nomeCampo: "Nome do modelo",
      assunto: "Assunto",
      corpo: "Mensagem",
      compartilhado: "Compartilhado",
      compartilhadoAjuda: "Compartilhado aparece para toda a equipe; sem compartilhar, só para você.",
      criadoEm: "Criado em",
      opcoes: "Opções",
      sim: "Sim",
      nao: "Não",
      editar: "Editar {{nome}}",
      excluir: "Excluir {{nome}}",
      confirmarExcluir: "Excluir o modelo {{nome}}?",
      confirmarExcluirTexto: "Os e-mails já enviados com ele não mudam.",
      vazio: "Não existem modelos de e-mail cadastrados.",
      salvo: "Modelo salvo",
      tags: "Tags",
      tagsAjuda: "Na hora de enviar, a tag vira o dado da negociação. Clique para pôr no texto.",
      inserirTag: "Pôr no texto",
      tag: {
        "contato-nome": "Nome do contato",
        "contato-cargo": "Cargo do contato",
        "deal-nome": "Nome da negociação",
        "deal-empresa": "Nome da empresa",
        "usuario-nome": "Usuário logado",
        tratamento: "Tratamento do contato (Sr., Sra. ou nada, se neutro)",
        "o/a": "Final conforme o tratamento: o, a ou o(a) (Prezado, Prezada, Prezado(a))",
      },
    },
  },
  vertical: "Vertical",
  verticalAjuda: "A empresa do grupo deste item; no ganho, cada vertical vira um contrato.",
  semVertical: "Sem vertical",
  exibir: "Exibir",
  propostaAtual: "Proposta atual",
  escolhaCatalogo: "Escolha um produto do catálogo",
  buscarProduto: "Buscar por nome ou código",
  criarProduto: "Criar novo produto/serviço",
  nomeProduto: "Nome",
  precoBase: "Preço-base",
  criar: "Criar",
  produtoCriado: "Produto criado no catálogo",
  todosProdutos: "Todos os produtos",
  nenhumProduto: "Nenhum produto.",
  cobranca: { recorrente: "Recorrente", avulso: "Único" },
  modeloPadrao: "Modelo padrão",
  propostasVazio: "Crie e envie propostas para seus clientes com os produtos desta negociação.",
  avancarStatus: "Avançar status",
  semProdutosTitulo: "Adicione produtos à negociação",
  semProdutosTexto: "A proposta usa os produtos e serviços da negociação. Adicione ao menos um na aba Produtos para criar a proposta.",
  irProdutos: "Adicionar produtos",
  agoraNao: "Agora não",
  enviadoPor: "Enviado por {{nome}} em {{data}}",
};

export const ficha2En: typeof ficha2Pt = {
  reabrir: "Reopen deal",
  reaberta: "Deal reopened",
  maisOpcoes: "More deal options",
  apagar: "Delete deal",
  playbook: "Open playbook",
  diasEtapa: "{{nome}} ({{dias}})",
  parabens: "Congratulations on the sale!",
  continuar: "Continue",
  vendaMarcada: "{{titulo}} was marked as won.",
  vendasMes_one: "This month, {{nome}} has made {{count}} sale, totaling {{total}}.",
  vendasMes_other: "This month, {{nome}} has made {{count}} sales, totaling {{total}}.",
  semResponsavel: "the deal with no owner",
  anotacao: "Note",
  criada: "Deal created",
  trocarEmpresa: "Change the deal's company",
  empresaExistente: "Company from the records",
  criarEmpresa: "Create new company",
  segmento: "Segment",
  url: "URL",
  endereco: "Address",
  abrirEmpresa: "Open company page",
  infoAdicional: "Additional information",
  cargo: "Job title",
  baseLegal: "Legal basis",
  basesLegais: {
    nao_sabe: "Not sure / No legal basis",
    consentimento: "Consent",
    legitimo_interesse: "Legitimate interest",
    execucao_contrato: "Contract performance",
    obrigacao_legal: "Legal obligation",
  },
  editarContato: "Edit {{nome}}",
  criarContato: "Create new contact",
  email: {
    de: "From",
    deAjuda: "Sent on your behalf by the workspace email.",
    cc: "CC",
    cco: "BCC",
    semCopias: "There is no other deal email to copy.",
    ccQuem: "CC: {{lista}}",
    selecionarModelo: "Select email template",
    modelosTitulo: "Email templates",
    modelos: "Template",
    configurarModelos: "Set up templates",
    selecionar: "Select",
    semModelos: "No email templates. Create them in CRM settings > Email templates.",
  },
  config: {
    secoes: { "modelos-email": "Email templates", preferencias: "Preferences" },
    grupos: { time: "Your team", processo: "Set up your sales process", automatize: "Automate processes", avancado: "Advanced", conta: "Account settings", produtosMarketing: "Marketing products", potencialize: "Boost your sales strategy", acompanhamento: "Administrator tracking and approval" },
    usuarios: "Invitations, users and teams",
    itens: { equipes: "Sales teams", etapasLead: "Lead stages", automacao: "Sales automation", marketing: "Marketing integration", importar: "Import data", multivendas: "Multi-sales", metas: "Goals", enriquecimento: "Company enrichment", integracoes: "Integrations", privacidade: "Data privacy", regionais: "Regional preferences", whatsapp: "Sales through WhatsApp", reWhatsapp: "AI through WhatsApp", assinatura: "Electronic signature", ia: "AI for deals and Sales Enablement", produtos: "Products and services", segmentos: "Segments", infoPre: "Predefined information", telefone: "Virtual phone", exportacoes: "Export management", acoesMassa: "Bulk action management", lixeira: "Trash", logsErros: "Error logs" },
    emBreve: "Coming soon",
    emBreveAjuda: "This setting is not available yet.",
    sugestoesTitulo: "Suggestions for you",
    sugestoes: {
      campos: "Create custom fields that match your sales process",
      camposBotao: "Create custom fields",
      modelos: "Create email templates to send to contacts from your deals",
      modelosBotao: "Create email templates",
      playbook: "Build your team's sales playbook for each pipeline stage",
      playbookBotao: "Set up playbook stages",
    },
    buscar: "Search settings",
    buscaPlaceholder: "Type to search, e.g.: email templates...",
    nada: "No settings with that name.",
    celebrar: "Sale congratulations",
    celebrarAjuda: "After marking the sale, shows the congratulations with the owner's sales this month.",
    modelosEmail: {
      intro: "Create email templates that can be sent to your contacts from your deals.",
      criar: "Add template",
      editarTitulo: "Edit email template",
      nome_one: "Email template ({{count}})",
      nome_other: "Email templates ({{count}})",
      nomeCampo: "Template name",
      assunto: "Subject",
      corpo: "Message",
      compartilhado: "Shared",
      compartilhadoAjuda: "Shared shows to the whole team; not shared, only to you.",
      criadoEm: "Created on",
      opcoes: "Options",
      sim: "Yes",
      nao: "No",
      editar: "Edit {{nome}}",
      excluir: "Delete {{nome}}",
      confirmarExcluir: "Delete the template {{nome}}?",
      confirmarExcluirTexto: "Emails already sent with it don't change.",
      vazio: "There are no email templates.",
      salvo: "Template saved",
      tags: "Tags",
      tagsAjuda: "When sending, the tag becomes the deal data. Click to add it to the text.",
      inserirTag: "Add to the text",
      tag: {
        "contato-nome": "Contact name",
        "contato-cargo": "Contact job title",
        "deal-nome": "Deal name",
        "deal-empresa": "Company name",
        "usuario-nome": "Logged-in user",
        tratamento: "Contact form of address (Mr., Ms. or nothing, if neutral)",
        "o/a": "Portuguese and Spanish ending by form of address (o, a or o(a))",
      },
    },
  },
  vertical: "Vertical",
  verticalAjuda: "The group company for this item; on winning, each vertical becomes a contract.",
  semVertical: "No vertical",
  exibir: "Show",
  propostaAtual: "Current proposal",
  escolhaCatalogo: "Choose a product from the catalog",
  buscarProduto: "Search by name or code",
  criarProduto: "Create new product/service",
  nomeProduto: "Name",
  precoBase: "Base price",
  criar: "Create",
  produtoCriado: "Product created in the catalog",
  todosProdutos: "All products",
  nenhumProduto: "No products.",
  cobranca: { recorrente: "Recurring", avulso: "One-time" },
  modeloPadrao: "Default template",
  propostasVazio: "Create and send proposals to your customers with this deal's products.",
  avancarStatus: "Advance status",
  semProdutosTitulo: "Add products to the deal",
  semProdutosTexto: "The proposal uses the deal's products and services. Add at least one in the Products tab to create the proposal.",
  irProdutos: "Add products",
  agoraNao: "Not now",
  enviadoPor: "Uploaded by {{nome}} on {{data}}",
};

export const ficha2Es: typeof ficha2Pt = {
  reabrir: "Reabrir negociación",
  reaberta: "Negociación reabierta",
  maisOpcoes: "Más opciones de la negociación",
  apagar: "Eliminar negociación",
  playbook: "Abrir playbook",
  diasEtapa: "{{nome}} ({{dias}})",
  parabens: "¡Felicitaciones por la venta!",
  continuar: "Continuar",
  vendaMarcada: "{{titulo}} se marcó como vendida.",
  vendasMes_one: "Este mes, {{nome}} ya hizo {{count}} venta, que suma {{total}}.",
  vendasMes_other: "Este mes, {{nome}} ya hizo {{count}} ventas, que suman {{total}}.",
  semResponsavel: "la negociación sin responsable",
  anotacao: "Anotación",
  criada: "Negociación creada",
  trocarEmpresa: "Cambiar la empresa de la negociación",
  empresaExistente: "Empresa del registro",
  criarEmpresa: "Crear nueva empresa",
  segmento: "Segmento",
  url: "URL",
  endereco: "Dirección",
  abrirEmpresa: "Abrir página de la empresa",
  infoAdicional: "Información adicional",
  cargo: "Cargo",
  baseLegal: "Base legal",
  basesLegais: {
    nao_sabe: "No sé decir / No tengo base legal",
    consentimento: "Consentimiento",
    legitimo_interesse: "Interés legítimo",
    execucao_contrato: "Ejecución de contrato",
    obrigacao_legal: "Obligación legal",
  },
  editarContato: "Editar {{nome}}",
  criarContato: "Crear nuevo contacto",
  email: {
    de: "De",
    deAjuda: "Sale en tu nombre por el correo del workspace.",
    cc: "CC",
    cco: "CCO",
    semCopias: "No hay otro correo de la negociación para copiar.",
    ccQuem: "CC: {{lista}}",
    selecionarModelo: "Seleccionar plantilla de correo",
    modelosTitulo: "Plantillas de correo",
    modelos: "Plantilla",
    configurarModelos: "Configurar plantillas",
    selecionar: "Seleccionar",
    semModelos: "No hay plantillas de correo. Créalas en Configuración del CRM > Plantillas de correo.",
  },
  config: {
    secoes: { "modelos-email": "Plantillas de correo", preferencias: "Preferencias" },
    grupos: { time: "Tu equipo", processo: "Configura tu proceso de venta", automatize: "Automatiza procesos", avancado: "Avanzado", conta: "Ajustes de tu cuenta", produtosMarketing: "Productos de marketing", potencialize: "Potencia tu estrategia de ventas", acompanhamento: "Seguimiento y aprobación de administradores" },
    usuarios: "Invitaciones, usuarios y equipos",
    itens: { equipes: "Equipos de ventas", etapasLead: "Etapas del lead", automacao: "Automatización de ventas", marketing: "Integración con Marketing", importar: "Importar datos", multivendas: "Multiventas", metas: "Metas", enriquecimento: "Enriquecimiento de empresas", integracoes: "Integraciones", privacidade: "Privacidad de datos", regionais: "Preferencias regionales", whatsapp: "Venta por WhatsApp", reWhatsapp: "IA por WhatsApp", assinatura: "Firma electrónica", ia: "IA para negociaciones y Sales Enablement", produtos: "Productos y servicios", segmentos: "Segmentos", infoPre: "Información predefinida", telefone: "Teléfono virtual", exportacoes: "Gestión de exportaciones", acoesMassa: "Gestión de acciones masivas", lixeira: "Papelera", logsErros: "Registros de errores" },
    emBreve: "Próximamente",
    emBreveAjuda: "Esta configuración aún no está disponible.",
    sugestoesTitulo: "Sugerencias para ti",
    sugestoes: {
      campos: "Crea campos personalizados de acuerdo con tu proceso de ventas",
      camposBotao: "Crear campos personalizados",
      modelos: "Registra plantillas de correo para enviar a los contactos desde las negociaciones",
      modelosBotao: "Crear plantillas de correo",
      playbook: "Arma el playbook de ventas de tu equipo en cada etapa del embudo",
      playbookBotao: "Configurar etapas del playbook",
    },
    buscar: "Buscar en la configuración",
    buscaPlaceholder: "Escribe para buscar, ej.: plantillas de correo...",
    nada: "Ninguna configuración con ese nombre.",
    celebrar: "Felicitaciones por la venta",
    celebrarAjuda: "Después de marcar la venta, muestra las felicitaciones con las ventas del mes del responsable.",
    modelosEmail: {
      intro: "Registra plantillas de correo que podrán enviarse a tus contactos desde tus negociaciones.",
      criar: "Agregar plantilla",
      editarTitulo: "Editar plantilla de correo",
      nome_one: "Plantilla de correo ({{count}})",
      nome_other: "Plantillas de correo ({{count}})",
      nomeCampo: "Nombre de la plantilla",
      assunto: "Asunto",
      corpo: "Mensaje",
      compartilhado: "Compartida",
      compartilhadoAjuda: "Compartida aparece para todo el equipo; sin compartir, solo para ti.",
      criadoEm: "Creada el",
      opcoes: "Opciones",
      sim: "Sí",
      nao: "No",
      editar: "Editar {{nome}}",
      excluir: "Eliminar {{nome}}",
      confirmarExcluir: "¿Eliminar la plantilla {{nome}}?",
      confirmarExcluirTexto: "Los correos ya enviados con ella no cambian.",
      vazio: "No hay plantillas de correo registradas.",
      salvo: "Plantilla guardada",
      tags: "Etiquetas",
      tagsAjuda: "Al enviar, la etiqueta se convierte en el dato de la negociación. Haz clic para ponerla en el texto.",
      inserirTag: "Poner en el texto",
      tag: {
        "contato-nome": "Nombre del contacto",
        "contato-cargo": "Cargo del contacto",
        "deal-nome": "Nombre de la negociación",
        "deal-empresa": "Nombre de la empresa",
        "usuario-nome": "Usuario conectado",
        tratamento: "Tratamiento del contacto (Sr., Sra. o nada, si es neutro)",
        "o/a": "Final según el tratamiento: o, a u o(a) (Estimado, Estimada, Estimado(a))",
      },
    },
  },
  vertical: "Vertical",
  verticalAjuda: "La empresa del grupo de este ítem; al ganar, cada vertical se vuelve un contrato.",
  semVertical: "Sin vertical",
  exibir: "Mostrar",
  propostaAtual: "Propuesta actual",
  escolhaCatalogo: "Elige un producto del catálogo",
  buscarProduto: "Buscar por nombre o código",
  criarProduto: "Crear nuevo producto/servicio",
  nomeProduto: "Nombre",
  precoBase: "Precio base",
  criar: "Crear",
  produtoCriado: "Producto creado en el catálogo",
  todosProdutos: "Todos los productos",
  nenhumProduto: "Ningún producto.",
  cobranca: { recorrente: "Recurrente", avulso: "Único" },
  modeloPadrao: "Plantilla predeterminada",
  propostasVazio: "Crea y envía propuestas a tus clientes con los productos de esta negociación.",
  avancarStatus: "Avanzar estado",
  semProdutosTitulo: "Agrega productos a la negociación",
  semProdutosTexto: "La propuesta usa los productos y servicios de la negociación. Agrega al menos uno en la pestaña Productos para crear la propuesta.",
  irProdutos: "Agregar productos",
  agoraNao: "Ahora no",
  enviadoPor: "Enviado por {{nome}} el {{data}}",
};
